import React from 'react';
import Body from '../Body/Body';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import TopHeader from "../../../components/common/Header/TopHeader";


function SmartList() {
    return (
        <main id="app">
            <TopHeader />
        <div className="SmartList" style={{backgroundColor: "#f2f2f2"}}>
            <Body />
            <Footer />
        </div>
        </main>
    );
}

export default SmartList;